import {
    addNewOrderByAdmin,
    addNewProcess,
    deleteAOrderByAdmin,
    deleteAProcess,
    getAllOrders,
    getAllOrdersToPrint,
    getAllProcessOfOrder,
    updateAProcess,
    updateOrderByAdmin,
    getAOrderByAdmin,
    getAOrderProcessByAdmin,
} from '../../services/orders'
import { errorHandler } from '../../utils/errorHandler'
import { notification } from '../notification/notificationActions'
import { orderTypes } from './orderTypes'

export const getAllOrdersAction = body => async dispatch => {
    dispatch({
        type: orderTypes.GET_ALL_ORDERS_START,
    })
    try {
        const { data } = await getAllOrders(body)
        // const { data: allData } = await getAllOrdersToPrint(body);
        dispatch({
            type: orderTypes.GET_ALL_ORDERS_SUCCESS,
            payload: data?.data,
            allOrdersToPrint: [],
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(dispatch, orderTypes.GET_ALL_ORDERS_FAILED, error)
    }
    dispatch({
        type: orderTypes.GET_ALL_ORDERS_END,
    })
}

//get a order by admin------
export const getAOrderByAdminAction = id => async dispatch => {
    dispatch({
        type: orderTypes.GET_A_ORDER_BY_ADMIN_START,
    })
    try {
        const { data } = await getAOrderByAdmin(id)
        dispatch({
            type: orderTypes.GET_A_ORDER_BY_ADMIN_SUCCESS,
            payload: data?.data,
        })
        // closeModal && closeModal()
    } catch (error) {
        errorHandler(dispatch, orderTypes.GET_A_ORDER_BY_ADMIN_FAILED, error)
    }
    dispatch({
        type: orderTypes.GET_A_ORDER_BY_ADMIN_END,
    })
}

export const addNewOrderByAdminAction = (body, tableBody, closeModal) => async (
    dispatch,
    getState
) => {
    const { allOrders } = getState().orders
    dispatch({
        type: orderTypes.ADD_NEW_ORDER_BY_ADMIN_START,
    })
    try {
        await addNewOrderByAdmin(body)
        const { data } = await getAllOrders(
            tableBody
                ? tableBody
                : {
                      name: '',
                      take: 10,
                      skip: 0,
                      status: null,
                      created_at: 'DESC',
                  }
        )
        // const { data: allData } = await getAllOrdersToPrint(body);
        dispatch({
            type: orderTypes.GET_ALL_ORDERS_SUCCESS,
            payload: data?.data,
            allOrdersToPrint: [],
            meta: data?.meta,
        })
        // const copyAllOrders = [...allOrders, { ...body, ...data?.data }]
        // dispatch({
        //   type: orderTypes.ADD_NEW_ORDER_BY_ADMIN_SUCCESS,
        //   payload: copyAllOrders,
        // })
        dispatch(
            notification({
                message: 'سفارش مورد نظر با موفقیت ایجاد شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.ADD_NEW_ORDER_BY_ADMIN_FAILED,
            error,
            allOrders
        )
    }
    dispatch({
        type: orderTypes.ADD_NEW_ORDER_BY_ADMIN_END,
    })
}

// ---------------- UPDATE ORDER BY ADMIN
export const updateOrderByAdminAction = (id, body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allOrders } = getState().orders
    const index = allOrders.findIndex(item => item.id === id)
    dispatch({
        type: orderTypes.UPDATE_ORDER_BY_ADMIN_START,
    })
    try {
        const { data } = await updateOrderByAdmin(id, body)
        allOrders[index] = {
            ...data?.data,
            status: body.status,
            order_item: [...body.products],
            purchaser: body.purchaser,
        }
        // const { data: allData } = await getAllOrdersToPrint(body);

        dispatch({
            type: orderTypes.UPDATE_ORDER_BY_ADMIN_SUCCESS,
            payload: allOrders,
        })
        dispatch(
            notification({
                message: 'سفارش مورد نظر با موفقیت ویرایش شد',
                variant: 'success',
            })
        )
        // closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.UPDATE_ORDER_BY_ADMIN_FAILED,
            error,
            allOrders
        )
    }
    dispatch({
        type: orderTypes.UPDATE_ORDER_BY_ADMIN_END,
    })
}

// -------------------- process actions -----------

//add order process by admin
export const addNewProcessAction = body => async (dispatch, getState) => {
    const { orderProcess } = getState().orders
    dispatch({
        type: orderTypes.ADD_NEW_PROCESS_BY_ADMIN_START,
    })
    try {
        const { data } = await addNewProcess(body)
        dispatch({
            type: orderTypes.ADD_NEW_PROCESS_BY_ADMIN_SUCCESS,

            payload: [
                ...orderProcess,
                { ...data?.data, process_item: body.products },
            ],
        })
        dispatch(
            notification({
                message: 'پردازش مورد نظر با موفقیت ایجاد شد',
                variant: 'success',
            })
        )
        // closeModal && closeModal();
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.ADD_NEW_PROCESS_BY_ADMIN_FAILED,
            error,
            orderProcess
        )
    }
    dispatch({
        type: orderTypes.ADD_NEW_PROCESS_BY_ADMIN_END,
    })
}

export const updateAProcessAction = (id, body) => async (
    dispatch,
    getState
) => {
    const { orderProcess } = getState().orders
    const index = orderProcess.findIndex(item => item.id === id)

    dispatch({
        type: orderTypes.UPDATE_PROCESS_BY_ADMIN_START,
        updatedID: id,
    })

    try {
        const { data } = await updateAProcess(id, body)
        orderProcess[index] = { ...data?.data, process_item: body.products }

        dispatch({
            type: orderTypes.UPDATE_PROCESS_BY_ADMIN_SUCCESS,
            payload: orderProcess,
            updatedID: id,
        })
        dispatch(
            notification({
                message: 'پردازش مورد نظر با موفقیت ویرایش شد',
                variant: 'success',
            })
        )
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.UPDATE_PROCESS_BY_ADMIN_FAILED,
            error,
            orderProcess
        )
    }
    dispatch({
        type: orderTypes.UPDATE_PROCESS_BY_ADMIN_END,
    })
}

export const deleteAProcessAction = (id, closeModal) => async (
    dispatch,
    getState
) => {
    const { orderProcess } = getState().orders
    const filteredProcess = orderProcess.filter(item => item.id !== id)
    dispatch({
        type: orderTypes.DELETE_A_PROCESS_START,
    })
    try {
        const { data } = await deleteAProcess(id)
        dispatch({
            type: orderTypes.DELETE_A_PROCESS_SUCCESS,
            payload: filteredProcess,
        })
        dispatch(
            notification({
                message: 'پردازش مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.DELETE_A_PROCESS_FAILED,
            error,
            orderProcess
        )
    }
    dispatch({
        type: orderTypes.DELETE_A_PROCESS_END,
    })
}

export const deleteAOrderByAdminAction = (id, closeModal, tableBody) => async (
    dispatch,
    getState
) => {
    // const { allOrders } = getState().orders
    // const filteredOrders = allOrders.filter((item) => item.id !== id)

    dispatch({
        type: orderTypes.DELETE_A_ORDER_BY_ADMIN_START,
    })
    try {
        await deleteAOrderByAdmin(id)
        const { data } = await getAllOrders(
            tableBody
                ? tableBody
                : {
                      name: '',
                      take: 10,
                      skip: 0,
                      status: null,
                      created_at: 'DESC',
                  }
        )
        // const { data: allData } = await getAllOrdersToPrint(body);
        dispatch({
            type: orderTypes.GET_ALL_ORDERS_SUCCESS,
            payload: data?.data,
            allOrdersToPrint: [],
            meta: data?.meta,
        })
        dispatch(
            notification({
                message: 'سفارش مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(dispatch, orderTypes.DELETE_A_ORDER_BY_ADMIN_FAILED, error)
    }
    dispatch({
        type: orderTypes.DELETE_A_ORDER_BY_ADMIN_END,
    })
}

//get a process for a order by dmin
export const getAOrderProcessAction = (id, body) => async dispatch => {
    dispatch({
        type: orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_START,
    })
    try {
        const { data } = await getAOrderProcessByAdmin(id, body)
        dispatch({
            type: orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(
            dispatch,
            orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_FAILED,
            error
        )
    }
    dispatch({
        type: orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_END,
    })
}
